import { useQuery } from '@tanstack/react-query'
import { useApiToken } from './useApiToken'
import { dashboardApi } from '../lib/api/dashboard'

export function useDashboardStats() {
  const getToken = useApiToken()
  return useQuery({
    queryKey: ['dashboard', 'stats'],
    queryFn: async () => {
      const token = await getToken()
      return dashboardApi.stats(token)
    },
    refetchInterval: 60_000,
  })
}

export function useDashboardActivity() {
  const getToken = useApiToken()
  return useQuery({
    queryKey: ['dashboard', 'activity'],
    queryFn: async () => {
      const token = await getToken()
      return dashboardApi.activity(token)
    },
    refetchInterval: 60_000,
  })
}
